// extracted by mini-css-extract-plugin
module.exports = {"article":"styles_article__8cUbg","header":"styles_header__1NQKH","headerText":"styles_headerText__12HPx","articlePart":"styles_articlePart__2ypkO","tag":"styles_tag__cHHgl"};